module.exports = __webpack_public_path__ + "static/media/gem.cc5539dd.svg";